import { css } from "lit";

export const accordionStyles = css`
  :host {
    display: block;
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
  }

  .accordion-item {
    border-radius: var(--sds-size-radius-600);
    border: 1px solid var(--sds-color-border-default-default);
    background: var(--sds-color-background-default-default);
    padding: var(--sds-size-radius-800);
  }

  details {
    color: var(--sds-color-text-default-default);
    font:
      normal var(--sds-typography-weight-medium) var(--sds-typography-heading-size) / 150%
        var(--sds-typography-family-title),
      sans-serif;

    &[open] {
      summary .icon-expand {
        transform: rotate(135deg);
      }

      & + .content {
        max-height: 800px;
        padding-top: var(--sds-size-space-400);
        transition:
          max-height 0.3s ease-in,
          padding-top 0.3s ease-in;
      }
    }
  }

  summary {
    list-style: none;
    cursor: pointer;
    font-weight: 600;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .icon-expand {
      display: flex;
      align-items: center;
      justify-content: center;
      transition: transform 0.3s ease-in-out;
    }
  }
  summary::-webkit-details-marker {
    display: none;
  }

  .content {
    max-height: 0;
    overflow: hidden;
    color: var(--sds-color-text-default-secondary);
    font:
      normal var(--sds-typography-weight-regular) var(--sds-typography-body-size-medium) / 140%
        var(--sds-typography-family-body),
      sans-serif;
    padding-top: 0;
    transition:
      max-height 0.3s ease-out,
      padding-top 0.3s ease-out;
    white-space: pre-wrap;
  }

  .faq-video {
    width: 100%;
    margin-top: var(--sds-size-space-400);
    border-radius: var(--sds-size-radius-600);
  }
`;
